import React from 'react'

const React_Assignment_6 = () => {
  return (
    <div>
      <h1>Assignment 6</h1>
    </div>
  )
}

export default React_Assignment_6
